/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { NormalizedHighlighter } from 'components/highlight/NormalizedHighlighter'
import { HLabel } from 'components/HLabel'
import theme from 'config/theme'
import { SituacaoProblema } from 'graphql/types.generated'
import React from 'react'
import { humanizeAge } from 'util/date/humanize-age'

import { Problema } from '../../../soap/aside/types/ProblemaModel'
import { SituacaoProblemaTag } from '../../SituacaoProblemaTag'
import { formatDate } from './AccordionProblemasModal'

export type HeaderAccordionProblemasModalProps = {
  problema: Problema
  dataNascimentoCidadao: LocalDate
  highlight?: string
}

export function HeaderProblemaModal(props: HeaderAccordionProblemasModalProps) {
  const {
    dataNascimentoCidadao,
    problema: { ciap, cid10, descricaoOutro, ultimaEvolucao, situacao, avaliadoAgora },
    highlight,
  } = props
  const { textStyles } = styles

  return (
    <HFlow alignItems='center' justifyContent='space-between'>
      <HFlow alignItems='center'>
        <Icon icon='angleDown' name='accordionAngleIcon' />
        <VFlow vSpacing={0}>
          <Heading level={4}>
            {ciap && (
              <React.Fragment>
                <NormalizedHighlighter searchWords={highlight} textToHighlight={ciap.descricao} splitWords={false} />
                <Text style={textStyles}>
                  {' '}
                  (CIAP2{' '}
                  <NormalizedHighlighter
                    searchWords={highlight}
                    textToHighlight={ciap.codigo}
                    splitWords={false}
                  />) {separator(!!cid10 || !!descricaoOutro)}
                </Text>
              </React.Fragment>
            )}
            {cid10 && (
              <React.Fragment>
                <NormalizedHighlighter searchWords={highlight} textToHighlight={cid10.nome} splitWords={false} />
                <Text style={textStyles}>
                  {' '}
                  (CID10{' '}
                  <NormalizedHighlighter
                    searchWords={highlight}
                    textToHighlight={cid10.codigo}
                    splitWords={false}
                  />) {separator(!!descricaoOutro)}
                </Text>
              </React.Fragment>
            )}
            {descricaoOutro && (
              <NormalizedHighlighter searchWords={highlight} textToHighlight={descricaoOutro} splitWords={false} />
            )}
          </Heading>
          <HLabel title='Início do problema:'>
            {ultimaEvolucao.dataInicio
              ? `${formatDate(ultimaEvolucao.dataInicio)} | ${humanizeAge(
                  dataNascimentoCidadao,
                  ultimaEvolucao.dataInicio
                )}`
              : '-'}
          </HLabel>
          {situacao === SituacaoProblema.RESOLVIDO ? (
            <HLabel title='Fim do problema:'>
              {ultimaEvolucao.dataFim
                ? `${formatDate(ultimaEvolucao.dataFim)} | ${humanizeAge(
                    dataNascimentoCidadao,
                    ultimaEvolucao.dataFim
                  )}`
                : '-'}
            </HLabel>
          ) : (
            <HLabel title='Última avaliação:'>
              {ultimaEvolucao.atualizadoEm ? `${formatDate(ultimaEvolucao.atualizadoEm)}` : 'Atendimento atual'}
            </HLabel>
          )}
        </VFlow>
      </HFlow>
      {situacao !== SituacaoProblema.RESOLVIDO && (
        <HFlow alignItems='flex-start'>
          <SituacaoProblemaTag situacao={situacao} />
          {avaliadoAgora && (
            <HFlow alignItems='center' hSpacing={0.3}>
              <Icon icon='clockOutline' color={theme.pallete.primary.c40} size={1} />
              <Text
                style={css`
                  color: ${theme.pallete.primary.c40};
                `}
              >
                Avaliado agora
              </Text>
            </HFlow>
          )}
        </HFlow>
      )}
    </HFlow>
  )
}

const separator = (expression: boolean): string => (expression ? ' | ' : '')

const styles = {
  textStyles: css`
    font-weight: initial;
  `,
}
